import React from "react";
import Select from "react-select";

const ALL_OPTION = { value: "__ALL__", label: "All" };

// selected === [] (or null) means "All" is in effect; onChange follows the same convention.
function MultiSelectFilter({ label, options, selected, onChange }) {
  const selectedValues = selected || [];
  const isAllSelected = selectedValues.length === 0;
  const allOptions = [ALL_OPTION, ...options];

  const value = isAllSelected
    ? [ALL_OPTION]
    : allOptions.filter((o) => selectedValues.includes(o.value));

  const handleChange = (newValue) => {
    const values = newValue || [];
    if (!values.length) {
      onChange([]);
      return;
    }
    const hasAll = values.some((v) => v.value === ALL_OPTION.value);
    const realValues = values.filter((v) => v.value !== ALL_OPTION.value).map((v) => v.value);
    if (hasAll) {
      // isAllSelected reflects the pre-change state: All was already showing -> a real
      // option was just added, drop All; otherwise All was just clicked -> collapse to All.
      onChange(isAllSelected ? realValues : []);
      return;
    }
    onChange(realValues);
  };

  return (
    <div className="d-flex align-items-center gap-2 mb-2">
      <label className="mb-0 fw-semibold">{label}</label>
      <Select
        className="z-10 w-64"
        isMulti
        isClearable={false}
        options={allOptions}
        value={value}
        onChange={handleChange}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </div>
  );
}

export default MultiSelectFilter;
